// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { CSSProperties, useMemo, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import S from './styles';

function useTabLine(tabs: string[], currentTab: string): [React.RefObject<HTMLDivElement>, CSSProperties | undefined] {
  const tabLine = useRef<HTMLDivElement>(null);

  const tabLineStyle = useMemo<CSSProperties | undefined>(() => {
    if (!tabLine.current || !tabLine.current.parentElement) return;

    const index = tabs.indexOf(currentTab);
    const containerLeft = tabLine.current.parentElement.getBoundingClientRect().left;
    const { left, width } = tabLine.current.parentElement.children[index].getBoundingClientRect();

    return {
      left: (left - containerLeft) + 'px',
      width: width + 'px',
    };
  }, [tabLine.current, currentTab]);

  return [tabLine as React.RefObject<HTMLDivElement>, tabLineStyle];
}

interface TabsProps extends React.ComponentPropsWithRef<'div'> {
  tabs: string[];
  currentTab: string;
  handsOnType: string;
  handleChangeTab: (tab: string) => void;
  setHandsOnType: React.Dispatch<React.SetStateAction<string>>;
}

const Tabs: React.FC<TabsProps> = (props) => {
  const {
    tabs,
    currentTab,
    handsOnType,
    handleChangeTab,
    setHandsOnType,
    ...otherProps
  } = props;

  const [tabLine, tabLineStyle] = useTabLine(tabs, currentTab);
  const [isShow, setIsShow] = useState(false);

  const handleHandsOnType = (type: string) => {
    setHandsOnType(type);
    handleChangeTab('B045');
  }

  const HistoryPopUp = (props: any) => {
    const isShow = props.isShow;
    return (
      <S.PopUpContainer
        onMouseEnter={() => handleMouseEnter('B045')}
        onMouseLeave={() => handleMouseLeave('B045')}
        isShow={isShow}
      >
        <S.List>
          <S.Item onClick={() => handleHandsOnType('lab')} isFocus={handsOnType === 'lab' && currentTab === 'B045'}><FormattedMessage id="B006"/></S.Item>
          <S.Item onClick={() => handleHandsOnType('challenge')} isFocus={handsOnType === 'challenge' && currentTab === 'B045'}><FormattedMessage id="B036"/></S.Item>
          <S.Item onClick={() => handleHandsOnType('exam')} isFocus={handsOnType === 'exam' && currentTab === 'B045'}><FormattedMessage id="B040"/></S.Item>
        </S.List>
      </S.PopUpContainer>
    )
  }

  const handleMouseEnter = (tab: string) => {
    if (tab === 'B045') {
      setIsShow(true);
    }
  }

  const handleMouseLeave = (tab: string) => {
    if (tab === 'B045') {
      setIsShow(false);
    }
  }

  return (
    <>
      <S.Container {...otherProps}>
        {
          tabs.map(tab => (
            <S.Tab
              isShown={currentTab == tab}
              key={tab}
              onClick={() => {
                if (tab !== 'B045') {
                  handleChangeTab(tab)
                }
              }}
              onMouseEnter={() => handleMouseEnter(tab)}
              onMouseLeave={() => handleMouseLeave(tab)}
            >
              <FormattedMessage
                description="Tab Name"
                id={tab}
              />
            </S.Tab>
          ))
        }
        <S.TabLine ref={tabLine} style={tabLineStyle} />
        <HistoryPopUp isShow={isShow}/>
      </S.Container>
    </>
  )
}

export { Tabs as default }
